import { render } from "./BuyTetherForm.vue?vue&type=template&id=277c2f31"
import script from "./BuyTetherForm.vue?vue&type=script&lang=js"
export * from "./BuyTetherForm.vue?vue&type=script&lang=js"
script.render = render

export default script